import { QueryClient, useQuery } from "@tanstack/react-query";

import { getAllNotifications } from "@services/notification";

type Params = {
  recipientWalletId: string;
  level1ResourceId: string;
  onlyNew: 1;
  outbox: 1;
  limit: number;
  page: number;
  fromDate?: Date;
  toDate?: Date;
};

type UseAllNotificationParams = {
  params?: Partial<Params>;
  [key: string]: any;
};

export const useAllNotification = ({
  params,
  ...options
}: UseAllNotificationParams = {}) => {
  return useQuery<any>({
    queryKey: ["notifications", params],
    queryFn: () => getAllNotifications(params),
    ...options,
  });
};

// Refetch every notifications query after a change. Cancel first: invalidating
// a query still on its first fetch reuses that fetch (react-query 4), whose
// answer may predate the change, e.g. the unread count when opening a
// notification marks it read as the page loads.
export const invalidateNotifications = async (queryClient: QueryClient) => {
  await queryClient.cancelQueries(["notifications"]);
  await queryClient.invalidateQueries(["notifications"]);
};
